import { render, staticRenderFns } from "./CurriculumDetails.vue?vue&type=template&id=103c88ef&scoped=true"
import script from "./CurriculumDetails.vue?vue&type=script&lang=js"
export * from "./CurriculumDetails.vue?vue&type=script&lang=js"
import style0 from "./CurriculumDetails.vue?vue&type=style&index=0&id=103c88ef&prod&scoped=true&lang=css"
import style1 from "./CurriculumDetails.vue?vue&type=style&index=1&id=103c88ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c88ef",
  null
  
)

export default component.exports